import { GumshoeUser } from '@/models';
import { HttpService } from '@/services/http.service';
import Cookies from 'js-cookie';
import VueRouter from 'vue-router';
import { Store } from 'vuex';

import * as ACTIONS from '../store/mutation-types';

export class UserService {
  constructor(
    public store: Store<any>,
    public router: VueRouter,
    public http: HttpService
  ) {}
  public currentUser(): GumshoeUser {
    const cu = this.store.getters.currentUser;
    if (cu) {
      return cu;
    }
    const json = localStorage.getItem('currentUser');
    if (json) {
      const user = new GumshoeUser(json);
      this.store.commit(ACTIONS.SET_CURRENT_USER, user);
      return user;
    }
    const cookie = Cookies.get(ACTIONS.COOKIE);
    if (cookie) {
      const user = new GumshoeUser(json);
      this.store.commit(ACTIONS.SET_CURRENT_USER, user);
      return user;
    } else {
      this.router.push('/login');
    }
    return new GumshoeUser(null);
  }
  public setCurrentUser(data: any, cookie: string) {
    const user = new GumshoeUser(cookie, data.data);
    console.log('user', data);
    this.store.commit(ACTIONS.SET_CURRENT_USER, user);
  }
  public clear() {
    localStorage.clear();
    this.store.commit(ACTIONS.SET_CURRENT_USER, null);
    this.store.commit(ACTIONS.LOGOUT);
  }

  public searchUsersByRole(role: string) {
    return this.http
      .get(`/slenderAuth/v1/Users/${role}`)

      .then(resp => {
        const users = resp.data.data;
        this.store.commit(ACTIONS.SET_USERS, users);
      });
  }
  public getUserByEmail(email: string) {
    return this.http.get(`/slenderAuth/v1/Users?email=${email}`).then(resp => {
      const user = resp.data.data;
      this.store.commit(ACTIONS.SET_USER, user);
    });
  }
  public addUserRole(userId: string, role: string) {
    return this.http.put(`/slenderAuth/v1/Users/${userId}/${role}`, {});
  }
  public removeUserRole(userId: string, role: string) {
    return this.http.delete(`/slenderAuth/v1/Users/${userId}/${role}`);
  }
  public removeUser(userId: string) {
    return this.http.delete(`/slenderAuth/v1/Users/${userId}`).then(resp => {
      this.store.commit(ACTIONS.COMPLETE);
    });
  }
  public addUser(
    email: string,
    username: string,
    password: string,
    roles: string[]
  ) {
    return this.http
      .put(`/slenderAuth/v1/Users/`, {
        email: email,
        username: username,
        password: password,
        roles: roles
      })
      .then(resp => {
        const user = resp.data.data;
        this.store.commit(ACTIONS.SET_USER, user);
      });
  }
  public changePassword(email: string, password: string, newPassword: string) {
    return this.http.post(
      `/slenderAuth/v1/Users/`,
      {
        email: email,
        password: newPassword,
        oldPassword: password
      },
      'application/json'
    );
  }
}
